export const paris = [
  {
    ll_id: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    ru_id: "412999",
    verified: "no",
    city: "paris",
    neigbourhood: "Observatoire",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "1620",
    price_vs_Market: "-1610",
    available_from: "12/19/21",
    admin_fee_type: "tcvPercentage",
    admin_fee_value: "20",
    link: "http://www.spotahome.com/paris/for-rent:apartments/412999",
  },
  {
    ll_id: "ce7887fa-8e62-46d5-b821-3f1310ecbeb4",
    ll_name: "city Cosy Paris",
    ru_id: "156293",
    verified: "yes",
    city: "paris",
    neigbourhood: "Louvre",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "1250",
    price_vs_Market: "-760",
    available_from: "12/26/21",
    admin_fee_type: "fixed",
    admin_fee_value: "300",
    link: "http://www.spotahome.com/paris/for-rent:apartments/156293",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "149688",
    verified: "no",
    city: "paris",
    neigbourhood: "Panthéon",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "2",
    price: "2500",
    price_vs_Market: "-730",
    available_from: "12/25/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/149688",
  },
  {
    ll_id: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    ru_id: "412980",
    verified: "no",
    city: "paris",
    neigbourhood: "Gobelins",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1091",
    price_vs_Market: "-669",
    available_from: "11/1/21",
    admin_fee_type: "tcvPercentage",
    admin_fee_value: "20",
    link: "http://www.spotahome.com/paris/for-rent:apartments/412980",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "400956",
    verified: "no",
    city: "paris",
    neigbourhood: "Louvre",
    ll_engagement: "low",
    property_type: "studio",
    rooms: "0",
    price: "1380",
    price_vs_Market: "-630",
    available_from: "12/2/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/400956",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "446322",
    verified: "no",
    city: "paris",
    neigbourhood: "Bourse",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1550",
    price_vs_Market: "-620",
    available_from: "11/5/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/446322",
  },
  {
    ll_id: "ce7887fa-8e62-46d5-b821-3f1310ecbeb4",
    ll_name: "city Cosy Paris",
    ru_id: "440736",
    verified: "yes",
    city: "paris",
    neigbourhood: "Vaugirard",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1300",
    price_vs_Market: "-610",
    available_from: "11/13/21",
    admin_fee_type: "fixed",
    admin_fee_value: "300",
    link: "http://www.spotahome.com/paris/for-rent:apartments/440736",
  },
  {
    ll_id: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    ru_id: "412982",
    verified: "no",
    city: "paris",
    neigbourhood: "Butte-Montmartre",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1190",
    price_vs_Market: "-580",
    available_from: "12/15/21",
    admin_fee_type: "tcvPercentage",
    admin_fee_value: "20",
    link: "http://www.spotahome.com/paris/for-rent:apartments/412982",
  },
  {
    ll_id: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    ru_id: "454156",
    verified: "no",
    city: "paris",
    neigbourhood: "Popincourt",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "1925",
    price_vs_Market: "-565",
    available_from: "12/20/21",
    admin_fee_type: "tcvPercentage",
    admin_fee_value: "20",
    link: "http://www.spotahome.com/paris/for-rent:apartments/454156",
  },
  {
    ll_id: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    ru_id: "601987",
    verified: "no",
    city: "paris",
    neigbourhood: "Butte-Montmartre",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "2568",
    price_vs_Market: "-532",
    available_from: "11/30/21",
    admin_fee_type: "tcvPercentage",
    admin_fee_value: "20",
    link: "http://www.spotahome.com/paris/for-rent:apartments/601987",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "268175",
    verified: "no",
    city: "paris",
    neigbourhood: "Luxembourg",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1750",
    price_vs_Market: "-530",
    available_from: "12/18/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/268175",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "434058",
    verified: "no",
    city: "paris",
    neigbourhood: "Bourse",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "2",
    price: "2000",
    price_vs_Market: "-530",
    available_from: "12/19/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/434058",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "121668",
    verified: "yes",
    city: "paris",
    neigbourhood: "Palais-Bourbon",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1525",
    price_vs_Market: "-525",
    available_from: "12/15/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/121668",
  },
  {
    ll_id: "91e16722-c1fb-4697-849e-16e21100e96a",
    ll_name: "Lokim Gestion",
    ru_id: "142487",
    verified: "no",
    city: "paris",
    neigbourhood: "Vaugirard",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "950",
    price_vs_Market: "-500",
    available_from: "12/24/21",
    admin_fee_type: "notDefined",
    link: "http://www.spotahome.com/paris/for-rent:apartments/142487",
  },
  {
    ll_id: "a926d616-2a06-4f6c-ae93-c1b21241591c",
    ll_name: "Lokim (No gestion)",
    ru_id: "222982",
    verified: "no",
    city: "paris",
    neigbourhood: "Bourse",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1690",
    price_vs_Market: "-500",
    available_from: "10/2/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/222982",
  },
  {
    ll_id: "bd38b98f-e609-434a-91c9-2cef0a09aea9",
    ll_name: "A Paris comme chez soi",
    ru_id: "266329",
    verified: "no",
    city: "paris",
    neigbourhood: "Vaugirard",
    ll_engagement: "low",
    property_type: "studio",
    rooms: "0",
    price: "972",
    price_vs_Market: "-478",
    available_from: "11/30/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/266329",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "435500",
    verified: "yes",
    city: "paris",
    neigbourhood: "Temple",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1750",
    price_vs_Market: "-440",
    available_from: "12/11/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/435500",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "455106",
    verified: "no",
    city: "paris",
    neigbourhood: "Luxembourg",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1750",
    price_vs_Market: "-440",
    available_from: "12/19/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/455106",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "441059",
    verified: "yes",
    city: "paris",
    neigbourhood: "Hôtel-de-Ville",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1750",
    price_vs_Market: "-420",
    available_from: "12/20/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/441059",
  },
  {
    ll_id: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    ru_id: "472290",
    verified: "yes",
    city: "paris",
    neigbourhood: "Observatoire",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "950",
    price_vs_Market: "-400",
    available_from: "12/18/21",
    admin_fee_type: "tcvPercentage",
    admin_fee_value: "20",
    link: "http://www.spotahome.com/paris/for-rent:apartments/472290",
  },
  {
    ll_id: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    ru_id: "439485",
    verified: "no",
    city: "paris",
    neigbourhood: "Vaugirard",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1450",
    price_vs_Market: "-390",
    available_from: "12/20/21",
    admin_fee_type: "tcvPercentage",
    admin_fee_value: "20",
    link: "http://www.spotahome.com/paris/for-rent:apartments/439485",
  },
  {
    ll_id: "4b7ed85e-d1d4-462c-a65f-c561c79541c0",
    ll_name: "PARIS EASY HOME",
    ru_id: "203895",
    verified: "no",
    city: "paris",
    neigbourhood: "Panthéon",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "2330",
    price_vs_Market: "-370",
    available_from: "12/21/21",
    admin_fee_type: "fixed",
    admin_fee_value: "1925",
    link: "http://www.spotahome.com/paris/for-rent:apartments/203895",
  },
  {
    ll_id: "91e16722-c1fb-4697-849e-16e21100e96a",
    ll_name: "Lokim Gestion",
    ru_id: "124932",
    verified: "yes",
    city: "paris",
    neigbourhood: "Vaugirard",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "1085",
    price_vs_Market: "-365",
    available_from: "11/1/21",
    admin_fee_type: "notDefined",
    link: "http://www.spotahome.com/paris/for-rent:apartments/124932",
  },
  {
    ll_id: "91e16722-c1fb-4697-849e-16e21100e96a",
    ll_name: "Lokim Gestion",
    ru_id: "593166",
    verified: "no",
    city: "paris",
    neigbourhood: "Hôtel-de-Ville",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1595",
    price_vs_Market: "-365",
    available_from: "12/6/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/593166",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "435498",
    verified: "no",
    city: "paris",
    neigbourhood: "Temple",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1550",
    price_vs_Market: "-350",
    available_from: "10/23/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/435498",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "455120",
    verified: "no",
    city: "paris",
    neigbourhood: "Reuilly",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1350",
    price_vs_Market: "-350",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/455120",
  },
  {
    ll_id: "ce7887fa-8e62-46d5-b821-3f1310ecbeb4",
    ll_name: "city Cosy Paris",
    ru_id: "152522",
    verified: "yes",
    city: "paris",
    neigbourhood: "Panthéon",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "850",
    price_vs_Market: "-340",
    available_from: "11/24/21",
    admin_fee_type: "fixed",
    admin_fee_value: "300",
    link: "http://www.spotahome.com/paris/for-rent:apartments/152522",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "131744",
    verified: "yes",
    city: "paris",
    neigbourhood: "Temple",
    ll_engagement: "low",
    property_type: "studio",
    rooms: "0",
    price: "1250",
    price_vs_Market: "-330",
    available_from: "12/16/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/131744",
  },
  {
    ll_id: "91e16722-c1fb-4697-849e-16e21100e96a",
    ll_name: "Lokim Gestion",
    ru_id: "124233",
    verified: "no",
    city: "paris",
    neigbourhood: "Observatoire",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "995",
    price_vs_Market: "-305",
    available_from: "11/23/21",
    admin_fee_type: "notDefined",
    link: "http://www.spotahome.com/paris/for-rent:apartments/124233",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "154727",
    verified: "yes",
    city: "paris",
    neigbourhood: "Hôtel-de-Ville",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1675",
    price_vs_Market: "-285",
    available_from: "11/28/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/154727",
  },
  {
    ll_id: "bf5cd43e-5ff4-42e3-ac35-0cb9ed70a788",
    ll_name: "Riccardo Vino",
    ru_id: "340669",
    verified: "no",
    city: "paris",
    neigbourhood: "Temple",
    ll_engagement: "high",
    property_type: "studio",
    rooms: "0",
    price: "1320",
    price_vs_Market: "-260",
    available_from: "9/30/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/340669",
  },
  {
    ll_id: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    ru_id: "413062",
    verified: "no",
    city: "paris",
    neigbourhood: "OTHER_paris",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1450",
    price_vs_Market: "-260",
    available_from: "10/10/21",
    admin_fee_type: "tcvPercentage",
    admin_fee_value: "20",
    link: "http://www.spotahome.com/paris/for-rent:apartments/413062",
  },
  {
    ll_id: "5d69ad68-5283-47f7-b259-a6b44ec7c902",
    ll_name: "International Home Network",
    ru_id: "432796",
    verified: "no",
    city: "paris",
    neigbourhood: "Palais-Bourbon",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1700",
    price_vs_Market: "-260",
    available_from: "12/20/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/432796",
  },
  {
    ll_id: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    ru_id: "412997",
    verified: "no",
    city: "paris",
    neigbourhood: "Temple",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "1330",
    price_vs_Market: "-250",
    available_from: "12/15/21",
    admin_fee_type: "tcvPercentage",
    admin_fee_value: "20",
    link: "http://www.spotahome.com/paris/for-rent:apartments/412997",
  },
  {
    ll_id: "bd38b98f-e609-434a-91c9-2cef0a09aea9",
    ll_name: "A Paris comme chez soi",
    ru_id: "259902",
    verified: "no",
    city: "paris",
    neigbourhood: "Temple",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1667",
    price_vs_Market: "-233",
    available_from: "12/3/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/259902",
  },
  {
    ll_id: "64242c1d-8365-488c-bca3-71430d1c5d04",
    ll_name: "PFA Travel",
    ru_id: "426201",
    verified: "no",
    city: "paris",
    neigbourhood: "Palais-Bourbon",
    ll_engagement: "high",
    property_type: "studio",
    rooms: "0",
    price: "1800",
    price_vs_Market: "-230",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/426201",
  },
  {
    ll_id: "4b207cb0-5805-4051-94a5-d965522a8c1d",
    ll_name: "Narjes Djebari",
    ru_id: "105287",
    verified: "yes",
    city: "paris",
    neigbourhood: "OTHER_paris",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "2",
    price: "530",
    price_vs_Market: "-220",
    available_from: "12/2/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/105287",
  },
  {
    ll_id: "c14258e1-814d-45b9-89b5-84624bcf514c",
    ll_name: "L'agence de Paris",
    ru_id: "468168",
    verified: "no",
    city: "paris",
    neigbourhood: "Vaugirard",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "1200",
    price_vs_Market: "-210",
    available_from: "11/30/21",
    admin_fee_type: "tcvPercentage",
    admin_fee_value: "20",
    link: "http://www.spotahome.com/paris/for-rent:apartments/468168",
  },
  {
    ll_id: "e1182cf2-1f6c-4261-8b5e-63060091e9fe",
    ll_name: "Mariam Rosier",
    ru_id: "137580",
    verified: "yes",
    city: "paris",
    neigbourhood: "Observatoire",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "2",
    price: "699",
    price_vs_Market: "-201",
    available_from: "12/22/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/paris/for-rent:apartments/137580",
  },
];
